<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <i class="iconfont icon-weizhi"></i>
      <span> {{ placeholder }}</span>
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <el-input :disabled="!enableEdit" size="medium" clearable :value="_value.addr" :placeholder="placeholder">
        <el-button slot="append" icon="el-icon-map-location" @click="showMapPicker"></el-button>
      </el-input>
      <w-dialog :title="'点击地图选择位置：' + position.addr" v-model="visible" @ok="selectOk">
        <div id="v-map" class="v-map" v-if="visible">
          <!-- <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"/>
          <el-amap class="amap-box" vid="amapDemo" :zoom="zoom" :center="center" :events="events">
            标记点
            <el-amap-marker vid="marker" v-if="position.zb.length > 0" :position="position.zb"/>
          </el-amap> -->
        </div>
        <div class="search-box">
          <el-select v-model="searchValue" clearable filterable remote placeholder="请输入关键词" @change="selectChange"
            @clear="clearSearch" :remote-method="remoteMethod" :loading="searchLoading">
            <el-option v-for="item in searchResultList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </w-dialog>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly" class="m-v-map">
      <field v-model="_value" :readonly="!enableEdit" clearable :placeholder="placeholder">
        <template #right-icon>
          <i class="el-icon-map-location" @click="selectPosition"></i>
        </template>
      </field>
      <popup v-model="visible" :style="popupStyle" position="left" lazy-render safe-area-inset-bottom>
        <nav-bar :title="$isNotEmpty(position.addr) ? position.addr : '请选择位置'" left-text="返回" right-text="确定" left-arrow
          @click-left="visible = false" @click-right="selectOk" />
        <!-- <div class="search-box" >
          <el-amap-search-box :search-option="searchOption" :on-search-result="onSearchResult"/>
        </div>
        <el-amap class="amap-box" vid="amapDemo" :zoom="zoom" :center="center" :events="events">
          <el-amap-marker vid="marker" v-if="position.zb.length > 0" :position="position.zb"/>
        </el-amap> -->
      </popup>

    </div>
    <div v-else>
      {{ _value.addr }}
    </div>
  </div>
</template>

<script>
import { Field, Popup, NavBar } from 'vant'
import componentMinxins from "../ComponentMinxins";
import dian from '@/assets/img/location.png'

export default {
  name: "Location",
  mixins: [componentMinxins],
  components: { Field, Popup, NavBar },
  props: {
    value: {
      default () {
        return {
          addr: '',
          zb: []
        }
      }
    },
    placeholder: {
      type: String,
      default: '请选择地理位置'
    },
    enableEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const _this = this
    return {
      visible: false,
      center: [121.59996, 31.197646],
      zoom: 14,
      position: {
        addr: '',
        zb: [117.120098, 36.6512]
      },
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      searchValue: '',
      searchResultList: [],
      searchLoading: false,
      events: {
        init: () => { },
        click: (e) => {
          console.log('eeeeeeeee', e)
          let { lng, lat } = e.lnglat;
          this.center = [lng, lat];
          this.position.zb = [lng, lat]
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all",
          });
          console.log('geocoder', geocoder)
          geocoder.getAddress([lng, lat], function (status, result) {
            console.log('status', status)
            console.log('result', result)
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                _this.position.addr = result.regeocode.formattedAddress;
                console.log('获取到位置', result.regeocode.formattedAddress)
              }
            }
          });
        },
      },
      popupStyle: {
        height: '100%',
        width: '100%',
        background: '#f7f7f9'
      }
    }
  },
  methods: {
    selectChange (val) {
      console.log('valvalvalval', val)
      if (val) {
        const data = this.searchResultList.find(item => item.id === val)
        this.addMarker(data.location)
        this.position.addr = data.address
      } else {
      }
    },
    addMarker (lnglat) {
      this._map.clearMap()
      const marker = new AMap.Marker({
        icon: new AMap.Icon({
          image: dian
        }),
        offset: new AMap.Pixel(-20, -40),
        extData: {
        },
        position: lnglat
      })
      this.position.zb = lnglat.toArray()
      this._map.add(marker)
      this._map.setFitView([marker], true)
    },
    clearSearch () {
      this.searchResultList = []
    },
    remoteMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        const autoComplete = new AMap.AutoComplete(this.searchOption);
        //根据关键字进行搜索 keyword 为搜索的关键词
        autoComplete.search(query, (status, result) => {
          //搜索成功时，result 即是对应的匹配数据
          console.log(result);
          if (status === 'complete' && result.info === 'OK') {
            this.searchResultList = result.tips
          }
          this.searchLoading = false
        })
      } else {
        this.searchResultList = []
      }
    },
    showMapPicker () {
      this.visible = true
      this.$nextTick(() => {
        this.initMap()
      })
    },
    initMap () {
      AMap.plugin(['AMap.AutoComplete', 'AMap.Geocoder'], function () {})
      this._map = new AMap.Map('v-map', {
        zoom: 11,
        doubleClickZoom: false
      })
      this._map.on('click', e => {
        this.addMarker(e.lnglat)
        this.getAddr(e.lnglat)
      })
    },
    getAddr (lnglat) {
      const geocoder = new AMap.Geocoder()
      geocoder.getAddress(lnglat, (status, result) => {
        if (status === "complete" && result.info === "OK") {
          this.position.addr = result.regeocode.formattedAddress
        }
      })
    },
    toLocation () {
      if (this.$isNotEmpty(this._value)) {
        var MSearch = new AMap.PlaceSearch(this.searchOption); //构造PlaceSearch类
        AMap.event.addListener(MSearch, "complete", val => {
          if (val.poiList.count > 0) {
            let center = val.poiList.pois[0];
            this.center = [center.location.lng, center.location.lat];
            this.position.zb = [center.location.lng, center.location.lat];
          }
        }); //返回结果
        MSearch.search(this._value); //关键字查询
      } else {
        this.getPosition()
      }
    },
    getPosition () {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        timeout: 10000,
        position: 'RB',
        panToLocation: true,
        showCircle: true,
        buttonOffset: new AMap.Pixel(10, 20),
        zoomToAccuracy: true,
      });
      geolocation.getCurrentPosition(function (status, result) {
        if (status !== 'error') {
          let lng = result.position.lng;
          let lat = result.position.lat;
          this.position.zb = [lng, lat]
          this.center = [lng, lat]
        } else {
          console.log('定位失败，需要https环境')
        }
      });
    },
    onSearchResult (pois) {
      if (pois.length > 0) {
        let center = pois[0];
        this.position.addr = center.name;
        this.center = [center.lng, center.lat];
        this.position.zb = [center.lng, center.lat];
      }
    },
    selectOk () {
      console.log('this.position.addr', this.position)
      this._value = this.position
      this.visible = false
    },
    selectPosition () {
      this.visible = true
    }
  }
}
</script>

<style lang="less" scoped>
.v-map {
  width: 100%;
  height: 400px;
  position: relative;

}

.search-box {
  position: absolute;
  top: 85px;
  right: 10px;
  min-width: 200px;
  opacity: 0.9;
}

.m-v-map {
  position: relative;

  .search-box {
    text-align: center;
    position: absolute;
    display: flex;
    justify-content: center;
    top: 60px;
    width: 100%;
  }
}
</style>
